import React from "react";

const Loading = () => {
  return (
    <div className="page-wrap loading">
      <div className="book-loader">
        <div className="book-loader__inner">
          <div className="book-loader__left" />
          <div className="book-loader__middle" />
          <div className="book-loader__right" />
        </div>
        <ul>
          <li />
          <li />
          <li />
          <li />
          <li />
          <li />
          <li />
          <li />
          <li />
          <li />
          <li />
          <li />
          <li />
          <li />
          <li />
          <li />
          <li />
          <li />
        </ul>
      </div>

      <span className="loading__text">Chargement...</span>
    </div>
  );
};

export default Loading;
